export default __webpack_public_path__ + "static/media/circle.10c49137.svg";